import Vue from "vue";

Vue.prototype.$order = Vue.observable(require('../airModels/order'))
Vue.prototype.$outlet = Vue.observable(require('../airModels/outlet'))